import other from './other'
import kbs from './kbs'
export default {
  other,
  kbs
}



// WEBPACK FOOTER //
// ./src/api/index.js